// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__2a6T5","colCheckbox":"styles_colCheckbox__1jh4p"};